import { produce } from "immer";

import type {
  Keyword,
  KeywordModifiers,
  KeywordTypes,
  ProfileSearchParams,
} from "common/types";

export default function useKeywords(
  keywords: ProfileSearchParams["keywords"],
  setSearchParams: (searchParams: Partial<ProfileSearchParams>) => void,
) {
  function addKeyword(keywordText: string, keywordType: KeywordTypes) {
    // make sure the keyword doesn't already exist for the same type
    if (
      keywords.find(
        ({ type, text }) => text === keywordText && type === keywordType,
      )
    ) {
      return;
    }
    setSearchParams({
      keywords: [
        ...keywords,
        { text: keywordText, type: keywordType, modifier: "optional" },
      ],
    });
  }
  function updateKeywordModifier(keyword: Keyword, modifier: KeywordModifiers) {
    setSearchParams({
      keywords: produce(keywords, (draftState) => {
        for (let i = 0; i < draftState.length; i += 1) {
          if (
            draftState[i].text === keyword.text &&
            draftState[i].type === keyword.type
          ) {
            draftState[i].modifier = modifier;
            return;
          }
        }
      }),
    });
  }
  function removeKeyword(keyword: Keyword) {
    setSearchParams({
      keywords: keywords.filter(
        ({ text, type }) => !(text === keyword.text && type === keyword.type),
      ),
    });
  }
  return { addKeyword, removeKeyword, updateKeywordModifier };
}
